import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    loading: false,
    error: {},
    alert: {},
    modalAlert: {},
    pusher: null,
    configs: {},
    recaptchaKey: "6LdlIicpAAAAABCMUABNkwi3JROLmbnfScbXAP4Ds",
    backdrop: false,
    menuNavOpen: false,
    loginResult: null, 
    user: null,
    isChangePassword: false,
    isChangeDataUser: false,
    isChangePhone: false,
    isChangeRgpd: false,
    isPortability: false,
    isForget: false,
    isCarteiraActive: true,
    isTransactionActive: false,
    isAccountActive: false,
    token: localStorage.getItem('token') || null
  },
  actions,
  getters,
  mutations,
};
